import type { CandleBucketSize, Timeframe } from "@opensea/graphql"

export const DEFAULT_BUCKET_SIZE_MAP = {
  ALL_TIME: "ONE_DAY",
  ONE_YEAR: "ONE_DAY",
  THIRTY_DAYS: "ONE_DAY",
  SEVEN_DAYS: "FOUR_HOURS",
  ONE_DAY: "FIFTEEN_MINUTES",
  ONE_HOUR: "ONE_MINUTE",
  // These timeframes are not supported in the UI
  FIFTEEN_MINUTE: "ONE_MINUTE",
  FIVE_MINUTE: "ONE_MINUTE",
  ONE_MINUTE: "ONE_MINUTE",
} as const satisfies Record<Timeframe, CandleBucketSize>

export const MOBILE_DEFAULT_BUCKET_SIZE_MAP = {
  ALL_TIME: "ONE_DAY",
  ONE_YEAR: "ONE_DAY",
  THIRTY_DAYS: "ONE_DAY",
  SEVEN_DAYS: "FOUR_HOURS",
  ONE_DAY: "ONE_HOUR",
  ONE_HOUR: "ONE_MINUTE",
  // These timeframes are not supported in the UI
  FIFTEEN_MINUTE: "ONE_MINUTE",
  FIVE_MINUTE: "ONE_MINUTE",
  ONE_MINUTE: "ONE_MINUTE",
} as const satisfies Record<Timeframe, CandleBucketSize>

export const MIN_BUCKET_SIZE_FOR_TIMEFRAME = {
  ALL_TIME: "ONE_DAY",
  ONE_YEAR: "ONE_DAY",
  THIRTY_DAYS: "FOUR_HOURS",
  SEVEN_DAYS: "ONE_HOUR",
  ONE_DAY: "FIVE_MINUTES",
  ONE_HOUR: "ONE_MINUTE",
  // These timeframes are not supported in the UI
  FIFTEEN_MINUTE: "ONE_MINUTE",
  FIVE_MINUTE: "ONE_MINUTE",
  ONE_MINUTE: "ONE_MINUTE",
} as const satisfies Record<Timeframe, CandleBucketSize>

export const MAX_BUCKET_SIZE_FOR_TIMEFRAME = {
  ALL_TIME: "ONE_DAY",
  ONE_YEAR: "ONE_DAY",
  THIRTY_DAYS: "ONE_DAY",
  SEVEN_DAYS: "FOUR_HOURS",
  ONE_DAY: "ONE_HOUR",
  ONE_HOUR: "ONE_MINUTE",
  // These timeframes are not supported in the UI
  FIFTEEN_MINUTE: "ONE_MINUTE",
  FIVE_MINUTE: "ONE_MINUTE",
  ONE_MINUTE: "ONE_MINUTE",
} as const satisfies Record<Timeframe, CandleBucketSize>
